// Debounce applied to the commute destination predictions fetch as the user types.
// Extracted so tests can disable it (mock to 0) instead of waiting on real timers.
export const PREDICTIONS_DEBOUNCE_MS = 300;
